import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    goodsInfo: {},
    arrangeGoodsInfo: {},
  },
  mutations: {
    // 同步修改 带参数
    changeGoodsInfo(state: any, args: any) {
      state.goodsInfo = args;
    },
    // 同步修改 带参数
    changeArrangeGoodsInfo(state: any, args: any) {
      state.arrangeGoodsInfo = args;
    },
  },
  actions: {
    // 异步修改
  },
});
